var map = {
	"./angular-locale_en": 20,
	"./angular-locale_en-ca": 18,
	"./angular-locale_en-ca.js": 18,
	"./angular-locale_en-us": 19,
	"./angular-locale_en-us.js": 19,
	"./angular-locale_en.js": 20,
	"./angular-locale_pt": 22,
	"./angular-locale_pt-br": 21,
	"./angular-locale_pt-br.js": 21,
	"./angular-locale_pt.js": 22
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 192;



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/core/i18n ^\.\/.*$
 ** module id = 192
 ** module chunks = 0
 **/